import { createContext } from 'react';

import { UsersMethodsContextType, UsersStateContextValueType } from './UsersContext.types';

export const UsersStateContext = createContext<UsersStateContextValueType | undefined>(undefined);
export const UsersMethodsContext = createContext<UsersMethodsContextType | undefined>(undefined);
